export default __webpack_public_path__ + "static/media/logo.fd494b25.svg";